module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ba-tab u-pt2",
    class: _vm.isActive ? 'is-active' : ''
  }, [_c('div', {
    staticClass: "ba-tab__icon"
  }, [(_vm.type === 'signUp') ? _c('sign-icon') : _vm._e(), _vm._v(" "), (_vm.type === 'logIn') ? _c('login-icon') : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "ba-tab__sign"
  }, [_vm._v("\n    " + _vm._s(_vm.sign) + "\n  ")])])
},staticRenderFns: []}